<template>
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M20.5 12H5.12142M11.5 5L5.20711 11.2929C4.81658 11.6834 4.81658 12.3166 5.20711 12.7071L11.5 19"
          stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>
